module.exports = __webpack_public_path__ + "8871949492d803ad31187b0b16321aef.png";